export const VERIFIED = 'verified';
export const NOT_FOUND = 'not_found';
export const UNAUTHORIZED = 'unauthorized';
export const UNAUTHORIZED_AGE = 'unauthorized_age';
export const LOWER_AGE_LIMIT = 'lower_age_limit';


// WEBPACK FOOTER //
// ./src/constants/AdultAuthValidType.js